var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"DasboardMain"}},[_c('NavBarDashboard'),_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('router-view',{staticClass:"container-dashboard-views"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }